import { Axios } from "@/config/axios";

const state = {};

const getters = {};

const actions = {
  getUsers({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(
        `/api/admin/users?page=${data.page}&perPage=${data.perPage}&ohpEuid=${data.ohpEuid}`
      )
        .then((response) => {
          resolve(response.data.data);
        })
        .catch(function(error) {
          reject(error.response);
        });
    });
  },
  storeCollaborator({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post("/api/user/store-collaborator", data)
        .then((response) => {
          resolve(response.data);
        })
        .catch(function(error) {
          reject(error.response);
        });
    });
  },
  getCollaborators({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`/api/user/get-collaborators?ohpEuid=${data.adminOhpEuid}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch(function(error) {
          reject(error.response);
        });
    });
  },
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
